import { FaStar } from "react-icons/fa";
import { BiParty } from "react-icons/bi";
import { GiPartyFlags, GiPartyHat, GiPartyPopper } from "react-icons/gi";
export const reviewdata = [
  {
    id: 1,
    image: <GiPartyFlags />,
    name: "Gwamz",
    rating: (
      <>
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
      </>
    ),
    content: <>This is the only event pushing UK music, it’s great. </>,
  },
  {
    id: 2,
    image: <GiPartyPopper />,
    name: "Rebecca",
    rating: (
      <>
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
      </>
    ),
    content: <>Me and my girls had A GREAT TIME!!</>,
  },
  {
    id: 3,
    image: <BiParty />,
    name: "Destiny",
    rating: (
      <>
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
      </>
    ),
    content: <>It was LIT!</>,
  },
  {
    id: 4,
    image: <GiPartyHat />,
    name: "Chris",
    rating: (
      <>
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
      </>
    ),
    content: (
      <>
        Everyone I’ve spoken to said they wish they knew about this months ago
      </>
    ),
  },
];
